/**
 * Shared easing curves.
 *
 * These are typed as fixed-length tuples on purpose: framer-motion 13 accepts
 * a cubic-bezier as [number, number, number, number], and a plain `number[]`
 * literal is no longer assignable.
 */
export type Cubic = [number, number, number, number];

/** decelerating, for most entrances */
export const EASE_OUT: Cubic = [0.22, 1, 0.36, 1];

/** symmetric, for morphs and wipes */
export const EASE_IN_OUT: Cubic = [0.76, 0, 0.24, 1];

/** hard expo, for full-screen panels */
export const EASE_EXPO: Cubic = [0.87, 0, 0.13, 1];

/**
 * Extracted from the reference's bundle: their custom curve is literally
 * `lusion(e) { return cubicBezier(e, .35, 0, 0, 1) }` — a fast attack with a
 * very long tail. Used for reveals, wipes, and UI choreography.
 */
export const EASE_LUSION: Cubic = [0.35, 0, 0, 1];
